export default __webpack_public_path__ + "static/media/quest.e8492fd0.png";